
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store-section/[id]",
      function () {
        return require("private-next-pages/store-section/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store-section/[id]"])
      });
    }
  